import{createContext as r,useContext as t}from"react";var n=r(null),o=function(){return t(n)};export{n as AppCommonsContext,o as useAppCommons};
